import {ChevronDown, ChevronUp} from 'lucide-react';
import {cn} from '@/lib/utils';

interface SortableHeaderCellProps {
  label: string;
  columnId: string;
  activeColumn: string | null;
  direction: 'asc' | 'desc';
  onSort: (columnId: string) => void;
  className?: string;
  /** Applied to the label text span — e.g. `line-clamp-2` to ellipsis long headers. */
  labelClassName?: string;
}

const SortableHeaderCell = ({
  label,
  columnId,
  activeColumn,
  direction,
  onSort,
  className,
  labelClassName,
}: SortableHeaderCellProps) => (
  <button
    type="button"
    onClick={() => onSort(columnId)}
    className={cn(
      'flex items-center gap-1 whitespace-nowrap hover:text-slate-900 transition-colors',
      className,
    )}
    title={label}
  >
    <span className={cn('min-w-0', labelClassName)}>{label}</span>
    <div className="flex flex-col flex-shrink-0">
      <ChevronUp
        className={cn(
          'h-3 w-3',
          activeColumn === columnId && direction === 'asc'
            ? 'text-primary'
            : 'text-muted-foreground opacity-40',
        )}
      />
      <ChevronDown
        className={cn(
          'h-3 w-3 -mt-1',
          activeColumn === columnId && direction === 'desc'
            ? 'text-primary'
            : 'text-muted-foreground opacity-40',
        )}
      />
    </div>
  </button>
);

export default SortableHeaderCell;
